import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'mds-skeleton-loader',
  templateUrl: './skeleton-loader.html',
  styleUrl: './skeleton-loader.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.width]': 'width()',
    '[style.height]': 'height()',
    '[class.circle]': `appearance() === 'circle'`,
    '[class.rounded-rectangle]': `appearance() === 'rounded-rectangle'`,
  },
})
export class SkeletonLoaderComponent {
  appearance = input<'circle' | 'rectangle' | 'rounded-rectangle'>('rectangle');
  width = input<string>();
  height = input<string>();
}
